import React from 'react';

import { Row, Col, Button, Layout, Breadcrumb, Steps } from 'antd/lib';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getIngresosPorRangoFecha from '../../../graphql/querys/ventas/getIngresosPorRangoFecha.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import FormRangoFechas from './FormRangoFechas';
import TablaMostrarIngresos from './TablaMostrarIngresos';

@graphql(getUsuario)
class IngresosPorRango extends React.Component {
  state = {
    ingresos: [],
    fechaInicio: '',
    fechaFin: '',
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    console.log(e);
    this.buscar();
  };

  buscar = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getIngresosPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        let colIngresos = res.data.getIngresosPorRangoFecha;
        let ingresos = _.map(colIngresos, ingreso => {
          return {
            ...ingreso,
            key: ingreso._id,
          };
        });

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          ingresos: ingresos,
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          step: 1,
          loading: false,
        });
      });
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
    });
  };

  render() {
    const { data } = this.props;
    if (data.loading || this.state.loading) {
      return <Loading />;
    }

    // if (!data.getUsuario) {
    //   return null;
    // }
    const { Step } = Steps;
    let { step } = this.state;
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');
    let fInicio = moment(this.state.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.state.fechaFin).format('DD/MM/YYYY');
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Ingresos Por Fecha</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Administración General</h1>
          <Steps className="stepsFormularios" current={step}>
            <Step title="Seleccionar Fechas" />
            <Step title="Visualizar Resultados" />
          </Steps>
          {step == 0 && <FormRangoFechas buscar={this.buscar} />}
          {step == 1 && (
            <div>
              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Organismo: {this.state.nombreOrganismo}
              </h2>

              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                Reporte para el rango de fechas de: {fInicio} - {fFin}
              </h3>

              <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                Fecha de generacion: {fGeneracion}
              </h5>

              <TablaMostrarIngresos
                onCancelar={this.onCancelar}
                organismo={this.state.nombreOrganismo}
                fechaInicio={this.state.fechaInicio}
                fechaFin={this.state.fechaFin}
                data={this.state.ingresos}
              />

              <Row>
                <Col span={8} offset={8}>
                  <Button
                    style={{ marginLeft: '55%', marginTop: 10 }}
                    type="danger"
                    onClick={() => this.onCancelar()}
                  >
                    Atras
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(IngresosPorRango);
